/** 接口现网中文原句 → msgKey。无 key 时前端按原句补译，避免国际版只剩通用失败。 */
export const FAIL_ZH_TO_KEY: Record<string, string> = {
  "名字不能重复": "error.template.nameDuplicated",
  "模板收藏达到最高上限200个": "error.template.favoriteLimit",
  "根据id查无此数据": "error.common.notFoundById",
  "查询异常，请稍后重试": "error.common.queryRetry",
  "没有查询到数据": "error.common.noData",
  "权限不允许": "error.common.permissionDenied",
  "请检查参数": "error.common.checkParams",
  "更新失败": "error.common.updateFailed",
  "保存失败": "error.common.saveFailed",
  "网络错误！": "error.common.networkError",
  "系统繁忙，请稍后重试": "error.common.busy",
  "发送失败，请稍后重试": "error.common.sendFailedRetry",
  "获取失败，请稍后重试": "error.common.fetchFailedRetry",
  "获取信息异常": "error.common.fetchInfoFailed",
  "任务不存在": "error.common.taskNotFound",
  "根据id未找到记录": "error.common.recordNotFound",
  "没有对应用户": "error.common.userNotFound",
  "不支持此类型": "error.common.unsupportedType",
  "公司ID不能为空": "error.common.companyIdRequired",
  "email个数超出限制": "error.common.emailLimit",
  "smsService服务异常": "error.sms.serviceError",
  "根据domain查找域名配置未找到": "error.sms.domainByDomainNotFound",
  "根据domainId查找域名配置未找到": "error.sms.domainByIdNotFound",
  "xike子账号必须指定手机号": "error.sms.xikePhoneRequired",
  "该手机号在封禁表中，禁止更换": "error.sms.phoneBanned",
  "根据phone未找到该手机号": "error.sms.phoneNotFound",
  "该手机号正在被service使用": "error.sms.phoneInUse",
  "该子账号没有其他备用手机号了，请申请新的手机号": "error.sms.noBackupPhone",
  "domainId 和 domain 必须有一个有值": "error.sms.domainOrDomainIdRequired",
  "集成参数异常或过期": "error.integration.paramsExpired",
  "公司不存在!": "error.integration.companyNotFound",
  "state invalid!！": "error.integration.stateInvalid",
  "根据模板id创建失败": "error.flow.createFromTemplateFailed",
  "campaignId不能为空": "error.campaign.idRequired",
  "campaignId不存在": "error.campaign.idNotFound",
  "该Campaign不是Email类型": "error.campaign.notEmailType",
  "campaignIds不能为空": "error.campaign.idsRequired",
  "一次最多查询5个campaignId": "error.campaign.idsQueryLimit",
  "Campaign 无有效折扣规则": "error.campaign.noDiscountRule",
  "Campaign 未生成 Shopify 规则": "error.campaign.shopifyRuleMissing",
  "折扣规则激活失败，请稍后重试": "error.campaign.discountActivateFailed",
  "WebPush内容为空": "error.campaign.webPushContentEmpty",
  "请输入所有必填项": "error.campaign.requiredFieldsMissing",
  "请勿重复提交，折扣规则正在保存中": "error.discount.savingInProgress",
  "搜索结果最多支持查看前1万条记录,请输入更精确的关键词缩小范围": "error.product.searchLimit",
  "字体名称已存在": "error.font.nameExists",
  "保存字体异常": "error.font.saveFailed",
  "字体已存在": "error.font.alreadyExists",
  "品牌资产保持资料异常": "error.brandAssets.saveFailed",
  "用户数据同步GoogleAds开启异常": "error.ads.googleEnableError",
  "用户数据同步GoogleAds暂停异常": "error.ads.googlePauseError",
  "用户数据同步FacebookAds开启异常": "error.ads.facebookEnableError",
  "用户数据同步FacebookAds暂停异常": "error.ads.facebookPauseError",
  "用户数据同步TikTokAds开启异常": "error.ads.tiktokEnableError",
  "用户数据同步TikTokAds暂停异常": "error.ads.tiktokPauseError",
  "用户数据同步GoogleAds开启失败": "error.ads.googleEnableFailed",
  "用户数据同步GoogleAds暂停失败": "error.ads.googlePauseFailed",
  "用户数据同步FacebookAds开启失败": "error.ads.facebookEnableFailed",
  "用户数据同步FacebookAds暂停失败": "error.ads.facebookPauseFailed",
  "用户数据同步TikTokAds开启失败": "error.ads.tiktokEnableFailed",
  "用户数据同步TikTokAds暂停失败": "error.ads.tiktokPauseFailed",
  "第三方营销ID不能为空": "error.fenqun.thirdPartyIdRequired",
  "多语言列表不能为空": "error.fenqun.localesRequired",
  "未配置App Proxy,请联系技术支持完成配置": "error.proxy.appProxyMissing",
  "getDsl error": "error.fenqun.getDslError",
  "companyId is null": "error.sms.companyIdNull",
  "domainId is null": "error.sms.domainIdNull",
  "domain is null": "error.sms.domainNull",
  "type is null": "error.sms.typeNull",
  "phone is null": "error.sms.phoneNull",
  "fail : name is null": "error.sms.dnsNameNull",
  "fail : rr is null": "error.sms.dnsRrNull",
  "fail : domain_id is null": "error.sms.dnsDomainIdNull",
  "fail : txt_value is null": "error.sms.dnsTxtNull",
  "流程名称不能相同，请修改！": "error.flow.nameDuplicated",
  "数据不存在！": "error.common.dataNotExist",
  "flow流程数据不存在！": "error.flow.dataNotExist",
  "路径不存在": "error.flow.pathNotExist",
  "路径ID无效": "error.flow.pathIdInvalid",
  "前置组件不在该分支，请选择正确的前置组件和路径": "error.flow.wrongPreNode",
  "分流器不能复制!": "error.flow.splitCannotCopy",
  "分流器不能移动!": "error.flow.splitCannotMove",
  "当前分支已经合流!": "error.flow.branchAlreadyMerged",
  "发起合流的路径和目标路径不能相同": "error.flow.mergeSamePath",
  "只能与当前分支的另一侧路径合流!": "error.flow.mergeOtherSide",
  "发起合流的路径必须包含动作节点!": "error.flow.mergeNeedAction",
  "包含未收口子分支的路径不能发起外层合流!": "error.flow.mergeNestedOpen",
  "未合流分支的汇合路径必须为空": "error.flow.mergeEmptyJoin",
  "目标路径中不存在指定的前置组件": "error.flow.mergeTargetMissing",
  "不能合流到分支节点与结束节点之间!": "error.flow.mergeBetweenSplitEnd",
  "当前分支未合流!": "error.flow.branchNotMerged",
  "合流后存在动作节点时必须选择继承路径!": "error.flow.mergeNeedInherit",
  "流程不存在": "error.flow.notExist",
  "指定的组件不是分流器": "error.flow.notSplitter",
  "分支配置不存在!": "error.flow.branchConfigMissing",
  "分支路径配置不完整!": "error.flow.branchPathIncomplete",
  "加入用户群条件存在已删除用户群，请修正后继续!": "error.flow.deletedSegment",
  "请完成订单妥投事件集成": "error.flow.needDeliveryIntegration",
  "不是自己公司的数据，不允许操作！": "error.flow.notOwnCompany",
  "启动失败：没有策略器!": "error.flow.startNoStrategy",
  "公司不存在或无权限!": "error.flow.companyNoPermission",
  "流程组件类型不能为空!": "error.flow.componentTypeEmpty",
  "不支持的流程组件类型!": "error.flow.unsupportedComponent",
  "流程路径ID为空或重复": "error.flow.pathIdEmptyOrDup",
  "流程组件ID为空或重复": "error.flow.componentIdEmptyOrDup",
  "流程路径中的组件顺序不一致": "error.flow.pathOrderMismatch",
  "流程起始路径不存在": "error.flow.startPathMissing",
  "分流器必须是路径最后一个组件!": "error.flow.splitMustBeLast",
  "分支路径配置重复!": "error.flow.branchPathDup",
  "分支路径不存在或归属错误!": "error.flow.branchPathWrong",
  "发送渠道不能为空或不支持!": "error.flow.channelEmpty",
  "邮件不能为空": "error.flow.emailEmpty",
  "邮件主题不能为空!": "error.flow.emailSubjectEmpty",
  "邮件内容不能为空!": "error.flow.emailContentEmpty",
  "发件人名称不能为空!": "error.flow.senderNameEmpty",
  "邮件主题过长": "error.flow.emailSubjectTooLong",
  "邮件预标题过长": "error.flow.emailPreheaderTooLong",
  "短信不能为空!": "error.flow.smsEmpty",
  "短信内容不能为空!": "error.flow.smsContentEmpty",
  "敏感词导致短信送达率低, 降低转化, 请立即修改": "error.flow.smsSensitive",
  "WebHook目标地址不能为空!": "error.flow.webhookUrlEmpty",
  "暂不支持彩信Flow组件!": "error.flow.mmsNotSupported",
  "延迟配置不能为空": "error.flow.delayEmpty",
  "请设置等待时间单位": "error.flow.delayUnitEmpty",
  "请设置等待时间": "error.flow.delayValueEmpty",
  "分支配置不能为空!": "error.flow.branchConfigEmpty",
  "ab测试规则不能为空!": "error.flow.abRuleEmpty",
  "ab测试ab通道配置不能为空!": "error.flow.abChannelEmpty",
  "ab测试ab通道流量配置比例不能为空!": "error.flow.abTrafficEmpty",
  "草稿内容异常，请重新进入流程编辑页面": "error.flow.draftInvalid",
  "模板数据不存在，请联系管理员初始化！": "error.template.dataMissing",
  "ID对应的数据不存在": "error.common.idDataNotExist",
  "已发布实验不允许取消！": "error.form.ab.publishedCannotCancel",
  "实验已取消或已发布，不允许删除！": "error.form.ab.cannotDelete",
  "测试实验已取消！": "error.form.ab.testCancelled",
  "实验名称过长，请修改！": "error.form.ab.nameTooLong",
  "实验已取消或已发布，不允许修改！": "error.form.ab.cannotEdit",
  "实验已取消或发布，请勿重复操作！": "error.form.ab.alreadyDone",
  "当前场景已有启用中实验！": "error.form.ab.sceneHasRunning",
  "实验弹窗数目错误！": "error.form.ab.formCountWrong",
  "订阅工具ID错误！": "error.form.ab.formIdWrong",
  "流量设置错误！": "error.form.ab.trafficWrong",
  "流量总和不等于100！": "error.form.ab.trafficNot100",
  "非发布状态实验无法选择获胜弹窗！": "error.form.ab.cannotPickWinner",
  "名称不能相同，请修改！": "error.form.nameDuplicated",
  "请勿重复操作！": "error.common.duplicateOp",
  "打开中的弹窗不支持直接删除！": "error.form.cannotDeleteOpen",
  "草稿中的弹窗不支持直接打开": "error.form.cannotOpenDraft",
  "开启中的AB实验不允许直接关闭，请先选择胜出的AB弹窗": "error.form.ab.cannotClosePickWinner",
  "多折扣码配置不完整!": "error.form.discountIncomplete",
  "订阅工具不存在": "error.form.notFound",
  "Coupon不能为空": "error.form.couponRequired",
  "请输入备用折扣码": "error.form.backupCodeRequired",
  "请输入步骤页折扣码": "error.form.needStepCoupon",
  "公司信息不能为空": "error.form.companyRequired",
  "该模板不支持全屏样式设置": "error.form.noFullscreen",
  "请输入步骤页动态折扣码规则": "error.form.needStepDiscountRule",
  "折扣码前缀过长": "error.form.prefixTooLong",
  "请选择值类型": "error.form.valueTypeRequired",
  "请输入折扣金额": "error.form.amountRequired",
  "请输入折扣百分比": "error.form.percentRequired",
  "请选择最低购买要求": "error.form.minPurchaseRequired",
  "请输入最低购买金额": "error.form.minAmountRequired",
  "请输入最低商品数量": "error.form.minQtyRequired",
  "请选择生效范围": "error.form.scopeRequired",
  "请至少选择1个系列": "error.form.needCollection",
  "请至少选择1个商品": "error.form.needProduct",
  "选择地点在该场景已有启用中弹窗": "error.form.locationSceneConflict",
  "同类型弹窗展示冲突，不可开启": "error.form.typeDisplayConflict",
  "订阅工具缺失必填项表单收集": "error.form.missingRequiredCollect",
  "手机号或者邮箱，至少有一个属性被添加": "error.form.needEmailOrPhone",
  "手机号或者邮箱,至少有一个为必填": "error.form.needEmailOrPhoneRequired",
  "属性为空": "error.form.propertyEmpty",
  "有属性为空": "error.form.propertyHasEmpty",
  "有属性重复": "error.form.propertyDup",
  "题目类型未选择": "error.form.questionTypeEmpty",
  "分群名称不能相同，请修改！": "error.fenqun.nameDuplicated",
  "该ID对应的分群不存在，请检查！": "error.fenqun.idNotFound",
  "分群信息异常": "error.fenqun.infoInvalid",
  "分群类型不支持抽样": "error.fenqun.sampleUnsupported",
  "分群抽样的人数大于分群人数了": "error.fenqun.sampleTooLarge",
  "分群要更新的状态不能为空！": "error.fenqun.statusRequired",
  "该ID对应的分群已经删除，请检查！": "error.fenqun.alreadyDeleted",
  "只有静态分群支持复制成员！": "error.fenqun.onlyStaticCopy",
  "源分群或目标分群不存在，请检查！": "error.fenqun.sourceOrTargetMissing",
  "源分群不存在，请检查！": "error.fenqun.sourceMissing",
  "源分群已经删除，不能复制！": "error.fenqun.sourceDeleted",
  "目标分群创建失败，请检查！": "error.fenqun.targetCreateFailed",
  "目标分群不存在，请检查！": "error.fenqun.targetMissing",
  "只有静态分群支持重试复制！": "error.fenqun.onlyStaticRetry",
  "该分群没有可重试的复制失败记录！": "error.fenqun.noRetryRecord",
  "请输入推荐渠道": "error.auth.channelRequired",
  "邮箱已注册，请重新输入": "error.auth.emailRegistered",
  "请输入6-20位，大小写字母+数字或符号组合的密码": "error.auth.passwordRule",
  "两次密码不一致，请重新输入": "error.auth.passwordMismatch",
  "注册失败，店铺已绑定其他账号": "error.auth.shopBoundOther",
  "用户不存在": "error.auth.userNotFound",
  "原密码不正确，请重新输入": "error.auth.oldPasswordWrong",
  "新密码与原密码一致，无需修改！": "error.auth.passwordUnchanged",
  "邮箱为空！": "error.auth.emailEmpty",
  "草稿ID不能为空": "error.flow.draftIdRequired",
  "草稿不存在或者草稿不是最新的，请重新进入流程编辑页面": "error.flow.draftStale",
  "邮件模板只能保存到策略器节点": "error.flow.emailOnlyOnStrategy",
  "草稿中的分流器不存在或已被删除，请刷新后重试": "error.flow.draftSplitterGone",
  "分流器配置不存在或不完整": "error.flow.splitterConfigIncomplete",
  "草稿中的路径不存在或已被删除，请刷新后重试": "error.flow.draftPathGone",
  "草稿中的组件不存在或已被删除，请刷新后重试": "error.flow.draftComponentGone",
  "草稿中的前置组件不存在或已被删除，请刷新后重试": "error.flow.draftPreGone",
  "当前流程未处于运行状态，无法进行运行中编辑": "error.flow.notRunningCannotLiveEdit",
  "仅支持检查运行中或暂停中的流程": "error.flow.checkRunningOrPausedOnly",
  "暂停前的流程版本快照不存在，请重新暂停后再启动": "error.flow.pauseSnapshotMissing",
  "流程发布操作已中断，请重试": "error.flow.publishInterrupted",
  "流程正在发布中，请稍后重试": "error.flow.publishInProgress",
  "当前流程未处于运行状态，无法暂停": "error.flow.notRunningCannotPause",
  "当前流程未处于运行状态，无法更新并启动": "error.flow.notRunningCannotUpdateRun",
  "流程已被更新，当前草稿不是最新版本，请重新进入流程编辑页面": "error.flow.draftNotLatest",
  "流程路径不能为空": "error.flow.pathRequired",
  "提交的路径不属于当前流程，请刷新后重试": "error.flow.pathNotBelong",
  "流程组件不能为空且必须指定组件类型": "error.flow.componentTypeRequired",
  "提交的组件不属于当前流程，请刷新后重试": "error.flow.componentNotBelong",
  "流程图中的路径或组件引用不能为空": "error.flow.graphRefRequired",
  "流程图中的路径或组件引用不存在，请刷新后重试": "error.flow.graphRefMissing",
  "流程不存在或无权操作": "error.flow.notFoundOrDenied",
  "活动不存在": "error.promotion.notFound",
  "推广活动名称已存在！": "error.promotion.nameDuplicated",
  "该账号已存在，请输入其他账号": "error.iam.accountExists",
  "启用失败，请修改账号角色": "error.iam.enableNeedRole",
  "该ID对应的账户不存在，请检查！": "error.iam.accountIdNotFound",
  "账号不存在": "error.iam.accountNotFound",
  "角色名称不可重复，请重新输入": "error.iam.roleNameDuplicated",
  "归因时间窗只可设置1-30天": "error.guide.attrWindow1to30",
  "归因时间窗只可设置1-7天": "error.guide.attrWindow1to7",
  "门店链接不可以为空": "error.guide.storeUrlRequired",
  "该类型的店铺暂不支持": "error.guide.shopTypeUnsupported",
  "登录邮箱不允许为空！": "error.guide.loginEmailRequired",
  "已经集成不允许修改了": "error.guide.alreadyIntegrated",
  "域名已被其商户验证": "error.guide.domainVerifiedByOther",
  "请输入默认发件人邮箱": "error.guide.defaultSenderRequired",
  "公司不存在": "error.common.companyNotFound",
  "店铺不存在": "error.shop.notFound",
  "折扣规则不能为空": "error.discount.ruleRequired",
  "折扣规则名称不可为空": "error.discount.nameRequired",
  "折扣规则名称最多100字符": "error.discount.nameTooLong",
  "折扣码前缀最多10字符": "error.discount.prefixMax10",
  "值类型不可为空": "error.discount.valueTypeRequired",
  "值内容不可为空": "error.discount.valueRequired",
  "固定金额必须大于0": "error.discount.amountGt0",
  "百分比仅支持1-100整数": "error.discount.percent1to100",
  "折扣规则名称已存在": "error.discount.nameExists",
  "折扣规则不存在": "error.discount.notFound",
  "备用折扣码不能为空": "error.discount.backupRequired",
  "此折扣规则已被一个或多个进行中的业务引用": "error.discount.inUse",
  "单次至多退订10个手机号": "error.contact.unsubPhoneMax10",
  "手机号格式异常,请重新输入": "error.contact.phoneFormat",
  "无退订信息": "error.contact.unsubEmpty",
  "当前店铺信息异常": "error.shop.infoInvalid",
  "index参数错误": "error.form.indexInvalid",
  "ID对应的公司不存在": "error.common.companyIdNotFound",
  "登录密码已更新, 请重新登录": "error.account.passwordUpdated",
};

export const FAIL_ZH_PATTERNS: Array<{
  re: RegExp;
  key: string;
  names: string[];
}> = [
  { re: /^(.+)的选项为空$/, key: 'error.form.optionEmpty', names: ['label'] },
  { re: /^(.+)的选项有重复数据$/, key: 'error.form.optionDup', names: ['label'] },
  { re: /^(.+)的其中一个选项为空$/, key: 'error.form.optionItemEmpty', names: ['label'] },
  { re: /^(.+)的选项值为空$/, key: 'error.form.optionValueEmpty', names: ['label'] },
  { re: /^(.+)手机号或者邮箱，至少有一个属性被添加$/, key: 'error.form.needEmailOrPhoneWithLabel', names: ['label'] },
  { re: /^(.+)不允许修改为(.+)$/, key: 'error.flow.statusCannotChange', names: ['from', 'to'] },
  { re: /^该ID的数据已经是(.+)，不需要操作！$/, key: 'error.flow.alreadyInStatus', names: ['status'] },
  { re: /^策略器[“"](.+)[”"]折扣区未完成配置，请核验$/, key: 'error.flow.strategyDiscountIncomplete', names: ['name'] },
  { re: /^(\d+)个邮箱退订成功，(\d+)个邮箱退订失败，(\d+)个邮箱无需重复退订$/, key: 'error.contact.unsubEmailResult', names: ['success', 'fail', 'skip'] },
  { re: /^(\d+)个手机号退订成功，(\d+)个手机号退订失败，(\d+)个手机号无需重复退订$/, key: 'error.contact.unsubPhoneResult', names: ['success', 'fail', 'skip'] },
];

export function matchFailZh(raw: string): { key: string; params?: Record<string, string> } | null {
  const text = (raw || '').trim();
  if (!text) {
    return null;
  }
  const exact = FAIL_ZH_TO_KEY[text];
  if (exact) {
    return { key: exact };
  }
  for (let i = 0; i < FAIL_ZH_PATTERNS.length; i += 1) {
    const item = FAIL_ZH_PATTERNS[i];
    const m = text.match(item.re);
    if (!m) {
      continue;
    }
    const params: Record<string, string> = {};
    item.names.forEach((name, idx) => {
      params[name] = m[idx + 1];
    });
    return { key: item.key, params };
  }
  return null;
}
